import { Pipe, PipeTransform } from '@angular/core';
import { StudentListing } from '../models';

@Pipe({
  name: 'studentListing'
})
export class StudentListingPipe implements PipeTransform {
  transform(student: StudentListing, args?: any): any {
    if (!student) {
      return '';
    }

    return `${student.lastName}, ${student.firstName}`;
  }
}
